import type { SSEEvent } from '../api/types.js';

/**
 * Resume cursor for the history poll and the SSE stream.
 *
 * The agent numbers its events 1, 2, 3… per session, while the API persists each user
 * prompt with an epoch-seconds id (event: 'prompt'). Taking "the last id seen" as the
 * cursor therefore jumps to ~1.79e9 after a restore or a page load, and every later
 * agent event (small id) is filtered out — the reply never shows until a reload.
 * Only the agent's own sequence may drive the cursor.
 */
export function lastAgentEventId(events: readonly SSEEvent[] | undefined): number {
  if (!events) return 0;
  let last = 0;
  for (const e of events) {
    if (e.event !== 'prompt' && e.id > last) last = e.id;
  }
  return last;
}
